<template>
    <div class="user-management">
        <div class="page-top-line">
            <h2 class="page-title">User - <span class="fw-semi-bold">Management</span></h2>
        </div>
        <b-button variant="success" v-if="hasAdminRole()" @click="syncWithAD({$toasted, tenantId:currentUser.selectedCountryId})"
                  class="mb-3">Sync with AD</b-button>
        <Widget title="List of users" >
            <v-client-table :data="users" :columns="columnsDatatable" :options="optionsDatatable">
                <div slot="Last logged in" slot-scope="props">
                    {{formatDate(props.row.lastLoggedIn)}}
                </div>
                <div slot="roles" slot-scope="props">
                    <span v-for="(authority, i) in props.row.userAuthorities"
                          class="flex inline" :key="i">
                        <b-badge class="mr-1" variant="info" pill>{{authority.role}}</b-badge>
                    </span>
                </div>
            </v-client-table>
        </Widget>
    </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import Widget from '../../../components/Widget/Widget';
  import Loader from '../../../components/Loader/Loader';
  import moment from 'moment';

  export default {
    name: "UserManagement",
    data() {
      return {
        popovers: {},
        showAlert: false,
        user: JSON.parse(localStorage.getItem('user') || {}),
        columnsDatatable: ['firstName', 'lastName', 'email', 'jobTitle', 'department', 'Last logged in', 'roles'],
        optionsDatatable: {
          perPage: 10,
          pagination: {chunk: 10, dropdown: false},
          texts: {filter: '', count: '', limit: ''},
          columnsClasses: {id: 'width-100'},
          skin: 'table table-striped',
          sortIcon: {
            base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
          },
          sortable: []
        }
      }
    },
    components: {Widget, Loader},
    async mounted() {
      if(this.currentUser == undefined || this.currentUser.id == null) {
        await this.fetchCurrentUser();
      }
      if(this.currentUser && this.currentUser.selectedCountryId){
        this.getUsersByTenantRequest(this.currentUser.selectedCountryId);
      }
    },
    computed: {
      ...mapState("auth", ["currentUser"]),
      ...mapState("users", ["users", "isReceiving", "isDeleting", "idToDelete"]),
      ...mapState("countries", ["selectedCountry", "countries"]),

    },
    watch:{
      selectedCountry: function (val) {
        this.getUsersByTenantRequest(val.id);
      }
    },
    methods: {
      ...mapActions("auth", ["fetchCurrentUser"]),
      ...mapActions("users", ["getUsersByTenantRequest", "syncWithAD"]),
      createNewProduct() {
        this.$router.push("/app/admin/user-management/create");
      },
      closePopover(id) {
        this.popovers[id] = false;
      },
      formatDate(date){
          return date ? moment.unix(date['seconds']).format('MMMM Do YYYY, h:mm:ss a') : '-'
      },
      hasAdminRole(){
        const user = this.currentUser ? this.currentUser : this.user;

        if(user && this.countries && this.selectedCountry) {
          const selectedCountryId = this.selectedCountry.id;
          const selectedCountry = this.countries.filter(c => c.id == selectedCountryId )
          if (selectedCountry && selectedCountry.length > 0) {
            const countryData = selectedCountry[0];
            const userAuthorities = user.userAuthorities;
            const adminAuthorities = userAuthorities.filter(a => a.role == 'ROLE_ROOT'
              || (a.role == 'ROLE_ADMIN' && countryData.code === a.tenantCode))
            if (adminAuthorities.length > 0) {
              return true;
            }
          }
        }
        return false;
      }
    }
  }
</script>

<style src="./UserManagement.scss" lang="scss">

</style>
